<template>
  <div>
    <div class="bg">
      <div class="title">联系我们</div>
      <div class="contact-box">
        <div class="contact">如有任何疑问请联系我们，我们竭诚为您服务<br/>客服时间 周一至周日9:00至19:00 <br/>联系邮箱
          {{ footerConfig.email||'bd@cpskd.cn' }}
        </div>
        <div class="qrcode-box">
          <div class="flex-col-center">
            <img class="qrcode-img" src="../assets/images/mp-qrcode.png" alt="">
            <div>公众号</div>
          </div>
          <div class="flex-col-center">
            <img class="qrcode-img" src="../assets/images/service-qrcode.png" alt="">
            <div>微信</div>
          </div>
          <div class="flex-col-center">
            <img class="qrcode-img" src="../assets/images/miniapp-qrcode.png" alt="">
            <div>小程序</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>
        <div class="footer-serve">
          <div class="h2">快速服务</div>
          <div class="serve-text">
            <span v-for="(service, index) in footerConfig.quickServices" :key="index">{{ service }}</span>
          </div>
        </div>
        <div class="footer-serve">
          <div class="h2">友情链接</div>
          <div class="serve-text">
            <a
              v-for="(link, index) in footerConfig.links"
              :key="index"
              :href="link.url"
              target="_blank"
              class="footer-link"
            >
              {{ link.title }}
            </a>
          </div>
        </div>
      </div>
      <a-divider/>
      <div class="footer-text">
        {{ footerConfig.companyName }} 版权所有 Copyright © {{ footerConfig.year }}
        <a :href="'https://beian.miit.gov.cn'" target="_blank">{{ footerConfig.icp }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    footerConfig: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 899px) {
  .footer {
    padding: 30px 15px;
    margin-top: -30px;
  }

  .bg {
    padding: 20px;
  }

  .title {
    font-size: 18px;
  }

  .contact {
    font-size: 12px;
    line-height: 22px;
    margin-top: 14px;
  }

  .qrcode-box {
    display: flex;

    .flex-col-center {
      margin-right: 40px;
      margin-top: 20px;
    }

    .qrcode-img {
      width: 58px;
      height: 58px;
      margin-bottom: 6px;
    }

    div {
      font-size: 12px;
    }
  }

  .footer-serve {
    margin-top: 30px;
    font-weight: bold;

    .h2 {
      font-size: 14px;
      margin-bottom: 6px;
    }

    .serve-text {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      span {
        margin-top: 6px;
        font-size: 12px;
      }
    }
  }

  .footer-text {
    font-size: 12px;
    color: #697085;
    text-align: center;
    line-height: 20px;
  }

}

@media only screen and (min-width: 990px) {
  .footer {
    padding: 0 200px 30px;
    margin-top: -60px;
  }

  .bg {
    padding: 40px 200px
  }

  .title {
    font-size: 36px;
    text-align: left;
  }

  .contact-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
  }

  .contact {
    margin-top: 30px;
    font-size: 18px;
    line-height: 36px;
  }

  .flex-col-center {
    .qrcode-img {
      width: 100px;
      height: 100px;
    }

    div {
      font-size: 14px;
      margin-top: 10px;
    }
  }

  .h2 {
    font-size: 18px;
  }

  .qrcode-box {
    display: flex;
    justify-content: space-between;
    gap: 10px; /* 控制子元素之间的间距 */
  }


  .footer-serve {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    width: 100%;

    .h2 {
      font-size: 14px;
      width: 20%;
    }

    .serve-text {
      margin-left: 30px;
      width: 80%;
      display: flex;
      justify-content: flex-start;
      gap: 10px;

      span {
        font-size: 14px;
      }
    }
  }

  .footer-text {
    text-align: center;
    color: #697085;
    font-size: 14px;
  }
}

.bg {
  background: url('../assets/images/bg@2x.png') no-repeat;
  box-sizing: border-box;
  background-size: 100% 250px;

  div {
    color: #fff;
  }
}

.title {
  font-weight: bold;
}

.footer-link {
  display: block;
  margin: 5px 0;
  font-size: 14px;
  text-decoration: none;
}

.footer-link:hover {
  text-decoration: underline;
}
</style>
